import { getRequest, postRequest } from '../utils/axios';

export const projectsService = {
    listProjects,
    getProject,
    createProject,
    getCurrentProject,
};

function listProjects(onSuccess, onError) {
  return getRequest(
    '/api/v1/projects/',
    (response) => {
      if (onSuccess) {
        return onSuccess(response);
      }
    },
    (error, response) => {
      if (onError) {
        return onError(error, response);
      }
    }
  );
}

function getProject(hash, onSuccess, onError) {
  return getRequest(
    `/api/v1/projects/${hash}/`,
    (response) => {
      if (onSuccess) {
        return onSuccess(response);
      }
    },
    (error, response) => {
      if (onError) {
        return onError(error, response);
      }
    }
  );
}

function createProject(name, onSuccess, onError) {
  const data = { name: name };
  
  return postRequest(
    '/api/v1/projects/',
    data,
    (response) => {
      if (onSuccess) {
        return onSuccess(response);
      }
    },
    (error, response) => {
      if (onError) {
        return onError(error, response);
      }
    }
  );
}

function getCurrentProject() {
  return localStorage.getItem('currentProjectHash');
}

